module.exports = __webpack_public_path__ + "static/media/youtubeIcon.215e5616.svg";